import { callPost } from '../../services/axios.js'
import { toast } from '../../components/CommonComponents/ToastComponent/toast'

import {
  CREATE_DP_TEMPLATE,
  UPDATE_DP_TEMPLATE,
} from '../actionTypes/dayparting.js'

export const getDpStats = (accessToken, spCampaignIds, sdCampaignIds, sbCampaignIds,
  lookback, timezone, signal) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/dayparting/getStats', {
    userId: currentUserId,
    spCampaignIds,
    sdCampaignIds,
    sbCampaignIds,
    lookback,
    timezone,
  }, accessToken, signal)
}

export const loadDpRules = (accessToken, campaignIds) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/dayparting/loadRules', {
    userId: currentUserId,
    campaignIds,
  }, accessToken).then(response => response.data)
}

export const saveDpRules = (accessToken, campaignIds, status, timezone,
  lookback, slots, templateIds) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/dayparting/saveRules', {
    userId: currentUserId,
    campaignIds,
    status,
    timezone,
    lookback,
    slots,
    templateIds,
  }, accessToken).then(() => {
    toast.show({
      title: 'Success',
      description: 'Successfully saved rules.',
    })
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to save rules.',
    })
  })
}

export const saveDpTemplate = (accessToken, name, timezone, slots,
  needApply = false, campaignIds = []) => (dispatch, getState) => {
  const { header: { currentUserId } } = getState()

  return callPost('/dayparting/saveTemplate', {
    name,
    timezone,
    slots,
    needApply,
    userId: currentUserId,
    campaignIds,
  }, accessToken).then((response) => {
    toast.show({
      title: 'Success',
      description: 'Successfully saved template.',
    })

    dispatch({
      type: CREATE_DP_TEMPLATE,
      template: response.data,
    })

    return response.data
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to save template.',
    })
    return null
  })
}

export const updateDpTemplate = (accessToken, templateId, name, timezone, slots) => (dispatch) => {
  return callPost('/dayparting/updateTemplate', {
    templateId,
    name,
    timezone,
    slots,
  }, accessToken).then((response) => {
    toast.show({
      title: 'Success',
      description: 'Successfully updated template.',
    })

    dispatch({
      type: UPDATE_DP_TEMPLATE,
      template: response.data,
    })
  }).catch((error) => {
    toast.show({
      title: 'Danger',
      description: error?.response?.data?.message || 'Failed to update template.',
    })
  })
}
